export enum UserRoleEnum {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  SYSTEM_USER = 'SYSTEM_USER',
  SYSTEM_SELLER = 'SYSTEM_SELLER',
}

export enum UserTeamRoleEnum {
  OWNER = 'OWNER',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
}
